import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';

const DropdownLabel = ({ label, error, dataTestId }) => {
  const classes = useStyles();
  return (
    <Typography
      component="h6"
      className={clsx(classes.subHeading, { [classes.errorLabel]: error })}
      data-testid={dataTestId}
      e43e3e
    >
      {label}
    </Typography>
  );
};

const useStyles = makeStyles((theme) => ({
  subHeading: {
    fontSize: '1rem',
    marginBottom: theme.spacing(1)
  },
  errorLabel: {
    color: 'red'
  }
}));

export default DropdownLabel;
